import { render, staticRenderFns } from "./JobsFeedbackCountPerDurationCard.vue?vue&type=template&id=1439ab7a&"
import script from "./JobsFeedbackCountPerDurationCard.vue?vue&type=script&lang=js&"
export * from "./JobsFeedbackCountPerDurationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports